import React, { useState } from "react";
import { Text, View, ScrollView } from "react-native";
import CustomPressable from "../../components/customPressable/customPressable";
import { CustomTextInput } from "../../components/customTextInput";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import AsyncStorage from '@react-native-async-storage/async-storage';
import axios from 'axios';
import Loader from "../../components/Loader/loader";
import { protocol } from "../../config/Constant";


export const DeviceRegistration = ({ handleGoHome, serverConfigInfo, setServerConfigInfo, handleNext }) => {

    const getStyles = useCssStyle();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handleInputChange = (field, value) => {
        setServerConfigInfo(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleProceed = async () => {
        console.log('Device Info:', serverConfigInfo);

        // Validate that required fields are filled
        if (!serverConfigInfo.serverIp || !serverConfigInfo.clientConfig) {
            dispatch(setRenderFlashMessage(true, {
                type: "danger",
                message: "Please fill in Server IP and Client Config"
            }));
            return;
        }

        setLoading(true);

        try {
            const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
            const room = await AsyncStorage.getItem('room');
            const rn = room || 'notLogin';

            // Create axios instance with the updated server IP
            const customConfigPath = axios.create({
                baseURL: serverConfigInfo.serverIp.startsWith("http")
                    ? `${serverConfigInfo.serverIp}/Connector/rest`
                    :  protocol == 'http' ? `http://${serverConfigInfo.serverIp}:8080/Connector/rest` : `https://${serverConfigInfo.serverIp}:8443/Connector/rest`,
                timeout: 30000,
            });

            // Call getServerDateTime API to validate the configuration
            const response = await customConfigPath.get(
                `/currentServerTimeDetails/fetch?dId=${DeviceIdentifier}&rn=${rn}`
            );

            console.log('Server validation response:', response.data);

            if (response.data) {
                handleNext();
            } else {
                dispatch(setRenderFlashMessage(true, {
                    type: "danger",
                    message: "Invalid server configuration"
                }));
            }
        } catch (error) {
            console.error('Server validation error:', error);
            dispatch(setRenderFlashMessage(true, {
                type: "danger",
                message: error.message || "Failed to connect to server. Please check your configuration."
            }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <View style={getStyles(['adminPanelModalChildContainer'])}>

            <View style={getStyles(['textContainer'])}>
                <Text style={getStyles(['label'])}>{t('admin_panel.device_name')}</Text>
                <CustomTextInput
                    value={serverConfigInfo.deviceName}
                    onChangeText={(v) => handleInputChange('deviceName', v)}
                />
            </View>

            <View style={getStyles(['textContainer'])}>
                <Text style={getStyles(['label'])}>{t('admin_panel.server_ip')}</Text>
                <CustomTextInput
                    value={serverConfigInfo.serverIp}
                    onChangeText={(v) => handleInputChange('serverIp', v)}
                />
            </View>

            <View style={getStyles(['textContainer'])}>
                <Text style={getStyles(['label'])}>{t('admin_panel.client_config')}</Text>
                <CustomTextInput
                    value={serverConfigInfo.clientConfig}
                    onChangeText={(v) => handleInputChange('clientConfig', v)}
                />
            </View>

            <View style={getStyles(['adminPanelModalButtonContainer'])} >
                <CustomPressable style={getStyles(['primaryBtn'])} disabled={loading} onPress={handleProceed}>
                    {loading ? (
                        <Loader size={'small'} style={getStyles(['primaryBtn_loader'])} />
                    ) : (
                        <Text style={getStyles(['primaryBtnTxt'])}>{t('admin_panel.primary_button')}</Text>
                    )}
                </CustomPressable>

                <CustomPressable style={getStyles(['secondaryBtn'])} disabled={loading} onPress={handleGoHome}>
                    <Text style={getStyles(['secondaryBtnTxt'])}>{t('admin_panel.secondary_button')}</Text>
                </CustomPressable>
            </View>
        </View>
    )
}